//specifying all types of actions peroformed on the application state.
//user & application related
export const UPDATE_USER = `UPDATE_USER`
export const UPDATE_CONFIG = `UPDATE_CONFIG`
